<mat-spinner style="position:fixed;top:50%;left:50%" *ngIf="!load"></mat-spinner>

<div class="lti-fp" *ngIf="load">

  <!-- Left: marketing panel -->
  <aside class="lti-fp-left">
    <div class="lti-fp-left-inner">

      <a routerLink="/" class="lti-fp-logo">
        <img src="assets/images/LTI-logo-white-v2.png" alt="LetsTimeIt" class="lti-brand-logo">

      </a>

      <div class="lti-fp-hero">
        <h1>Get back in<br/>control.</h1>
        <p>Reset your password securely. We'll send a one-time code to verify your identity.</p>
      </div>

      <div class="lti-fp-steps">
        <div class="lti-fp-step lti-fp-step-active">
          <div class="lti-fp-step-badge">1</div>
          <div>
            <div class="lti-fp-step-title">Enter your email</div>
            <div class="lti-fp-step-desc">We'll send a verification code.</div>
          </div>
        </div>
        <div class="lti-fp-step">
          <div class="lti-fp-step-badge">2</div>
          <div>
            <div class="lti-fp-step-title">Verify the code</div>
            <div class="lti-fp-step-desc">6-digit OTP sent to your inbox.</div>
          </div>
        </div>
        <div class="lti-fp-step">
          <div class="lti-fp-step-badge">3</div>
          <div>
            <div class="lti-fp-step-title">Set new password</div>
            <div class="lti-fp-step-desc">Choose a strong, unique password.</div>
          </div>
        </div>
      </div>

      <div class="lti-fp-footer">
        <span>© 2026 LetsTimeIt Inc.</span>
      </div>

    </div>
  </aside>

  <!-- Right: form panel -->
  <main class="lti-fp-right">
    <form class="lti-fp-form-wrap" [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmit()">

      <a routerLink="/" class="lti-fp-back">
        <mat-icon>arrow_back</mat-icon>
        Back to sign in
      </a>

      <h2 class="lti-fp-title">Forgot password?</h2>
      <p class="lti-fp-sub">Enter your account email and we'll send you a reset code.</p>

      <div class="lti-fp-fields">

        <div class="lti-field-wrap">
          <label class="lti-inp-label">Email address</label>
          <div class="lti-input-box" [class.lti-input-invalid]="frmCtrl.email.invalid && frmCtrl.email.touched">
            <mat-icon class="lti-input-ico">mail_outline</mat-icon>
            <input type="email" formControlName="email" [maxlength]="150"
              class="lti-input" placeholder="you@company.com" />
          </div>
          <span class="lti-err" *ngIf="frmCtrl.email.invalid && frmCtrl.email.touched">{{errorMessage.email}}</span>
        </div>

        <div class="lti-err-block" *ngIf="error">{{error}}</div>

        <button class="lti-submit-btn" type="submit" [disabled]="!submitable">
          <mat-spinner *ngIf="processing" [diameter]="20"
            style="--mdc-circular-progress-active-indicator-color:#0f0e0a" class="mx-auto"></mat-spinner>
          <span *ngIf="!processing">Send reset code</span>
        </button>

      </div>

      <p class="lti-fp-hint">
        Remember your password? <a routerLink="/" class="lti-link">Sign in</a>
      </p>

    </form>
  </main>

</div>
